import React, { useState, useCallback } from 'react';
import { SysI_Analizadores } from '../../../types/types.analizadores';
import ModalTracerByAnalyzer from './Modals/ModalTracerByAnalyzer';

// Singleton para manejar el estado del modal globalmente
class ModalManagerSingleton {
  private listeners: ((isOpen: boolean, analyzer: SysI_Analizadores | null) => void)[] = [];
  private isOpen = false;
  private selectedAnalyzer: SysI_Analizadores | null = null;

  subscribe(listener: (isOpen: boolean, analyzer: SysI_Analizadores | null) => void) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  openModal(analyzer: SysI_Analizadores) {
    this.isOpen = true;
    this.selectedAnalyzer = analyzer;
    this.notifyListeners();
  }

  closeModal() {
    this.isOpen = false;
    this.selectedAnalyzer = null;
    this.notifyListeners();
  }

  private notifyListeners() {
    this.listeners.forEach(listener => {
      listener(this.isOpen, this.selectedAnalyzer);
    });
  }

  getState() {
    return { isOpen: this.isOpen, selectedAnalyzer: this.selectedAnalyzer };
  }
}

export const modalManager = new ModalManagerSingleton();

// Componente que renderiza el modal
export const ModalRenderer: React.FC = () => {
  const [modalState, setModalState] = useState(() => modalManager.getState());

  React.useEffect(() => {
    return modalManager.subscribe((isOpen, analyzer) => {
      setModalState({ isOpen, selectedAnalyzer: analyzer });
    });
  }, []);

  const handleClose = useCallback(() => {
    modalManager.closeModal();
  }, []);

  if (!modalState.isOpen || !modalState.selectedAnalyzer) {
    return null;
  }

  return (
    <ModalTracerByAnalyzer 
      onClose={handleClose} 
      analyzer={modalState.selectedAnalyzer} 
      orientation='horizontal' 
    />
  );
};
